<template>
  <div class="flex justify-center">
    <ul class="flex">
      <li>
        <button class="px-4 py-2 bg-white rounded-l hover:bg-gray-300 border"
          :class="itIsFirstPage ? 'text-gray-500' : 'text-gray-700'" :disabled="itIsFirstPage"
          @click="handleChangePage(1)">
          <i class="fas fa-angles-left"></i>
        </button>
      </li>
      <li>
        <button class="px-4 py-2 bg-white hover:bg-gray-300 border-y border-r"
          :class="itIsFirstPage ? 'text-gray-500' : 'text-gray-700'" :disabled="itIsFirstPage"
          @click="handleChangePage(page - 1)">
          <i class="fas fa-angle-left"></i>
        </button>
      </li>
      <li v-for="item in pageList" :key="item">
        <button class="px-4 py-2 hover:bg-gray-300 border-r border-y"
          :class="page === item ? 'bg-emerald-500 text-white' : 'bg-white text-gray-700'"
          @click="handleChangePage(item)">
          {{ item }}
        </button>
      </li>
      <li>
        <button class="px-4 py-2 bg-white hover:bg-gray-300 border-r border-y"
          :class="itIsLastPage ? 'text-gray-500' : 'text-gray-700'" :disabled="itIsLastPage"
          @click="handleChangePage(page + 1)">
          <i class="fas fa-angle-right"></i>
        </button>
      </li>
      <li>
        <button class="px-4 py-2 bg-white hover:bg-gray-300 rounded-r border-r border-y"
          :class="itIsLastPage ? 'text-gray-500' : 'text-gray-700'" :disabled="itIsLastPage"
          @click="handleChangePage(totalPages)">
          <i class="fas fa-angles-right"></i>
        </button>
      </li>
    </ul>
  </div>
</template>
<script>
export default {
  props: {
    page: {
      type: Number,
    },
    totalPages: {
      type: Number,
    },
  },

  computed: {
    itIsFirstPage() {
      return this.page === 1;
    },
    itIsLastPage() {
      return this.page === this.totalPages;
    },
    firstPageToShow() {
      let firstPageToShow = (this.page || 1) - 2;
      if (firstPageToShow < 1) {
        firstPageToShow = 1;
      }
      return firstPageToShow;
    },
    lastPageToShow() {
      let lastPageToShow = (this.page || 1) + 2;
      const totalPages = this.totalPages || 1;
      if (lastPageToShow > totalPages) {
        lastPageToShow = totalPages;
      }
      return lastPageToShow;
    },
    pageList() {
      let pageList = [];
      for (let i = this.firstPageToShow; i <= this.lastPageToShow; i++) {
        pageList.push(i);
      }
      return pageList;
    }
  },

  methods: {
    handleChangePage(page) {
      this.$emit('changePage', page);
    },
  }
};
</script>
